import styled from 'styled-components';

export const StyledUserApprovalList = styled.div`
  margin-top: 15px;

  .ual-wrapper {
    &-search {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 16px;

      &-left {
        display: flex;
        align-items: center;
        gap: 12px;

        > div {
          font-size: 14px;
          line-height: normal;

          > div {
            min-width: 250px;
          }
        }
      }

      &-right {
        display: flex;
        align-items: center;
        gap: 12px;
      }
    }

    &-table {
      > div {
        min-width: 100%;

        .MuiPaper-root {
          max-height: 100% !important;
          box-shadow: none !important;
        }
      }
    }
  }
`;

export const StyledMobildBox = styled.div`
  text-align: center;
`;
